<template>
  <div>
    <div v-if="pendingConfirmation">
      <dd-button @click="verifyRun" :small="true">
        <template #icon>
          <AutoRenewIcon class="icon-size-md"/>
        </template>
        controle vereist
      </dd-button>
    </div>
    <div v-else-if="hasBeenRun">
      <div v-if="untilNextRun">
        <a-tooltip>
          <template #title>
            Laatse keer gedraaid: {{ lastRun }}
          </template>
          <dd-button :small="true" :outline="true">
            <template #icon>
              <AutoRenewIcon class="icon-size-md"/>
            </template>
            {{ untilNextRun }}
          </dd-button>
        </a-tooltip>
      </div>
      <div v-else>
        <span class="flex-row align-items-center gap-xxs font-size-sm">
          <AutoRenewIcon class="icon-size-md"/>
          {{ lastRun }}
        </span>
      </div>
    </div>
    <div v-else>
      <span class="flex-row align-items-center gap-xxs font-size-sm">
        <AutoRenewOffIcon class="icon-size-md"/>
        nooit gedraaid
      </span>
    </div>
  </div>
</template>

<script>
import { RunIntervalEnum } from '../enums'
import { mapMutations, mapState } from 'vuex'
import moment from 'moment/moment'

export default {
  name: 'AutomationNextRunComponent',
  created () {
  },
  props: {
    automationInterface: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapMutations(`$_automation`, {
      setShowResultConfirmModal: 'SET_SHOW_RESULT_CONFIRM_MODAL',
    }),
    verifyRun () {
      this.setShowResultConfirmModal(true)
    },
    addInterval (moment, amount = 1) {
      switch (this.runInterval) {
        case RunIntervalEnum.DAILY:
          moment.add(amount, 'days')
          break
        case RunIntervalEnum.WEEKLY:
          moment.add(amount, 'weeks')
          break
        case RunIntervalEnum.MONTHLY:
          moment.add(amount, 'months')
          break
      }

      return moment
    },
    subInterval (moment, amount = 1) {
      switch (this.runInterval) {
        case RunIntervalEnum.DAILY:
          moment.subtract(amount, 'days')
          break
        case RunIntervalEnum.WEEKLY:
          moment.subtract(amount, 'weeks')
          break
        case RunIntervalEnum.MONTHLY:
          moment.subtract(amount, 'months')
          break
      }

      return moment
    }
  },
  computed: {
    ...mapState('$_automation', {
      showResultConfirmModal: 'showResultConfirmModal',
    }),
    pendingConfirmation () {
      return this.automationInterface?.pending_confirmation
    },
    hasBeenRun () {
      return !!this.automationInterface?.last_ran_at
    },
    runInterval () {
      return this.automationInterface?.run_interval
    },
    lastRun () {
      return moment(this.automationInterface?.last_ran_at).fromNow()
    },
    untilNextRun () {
      if (this.automationInterface?.run_interval === RunIntervalEnum.NEVER || this.automationInterface?.run_interval === RunIntervalEnum.ONCE) return

      const lastRunMoment = moment(this.automationInterface?.last_ran_at)
      const lastInterval = this.subInterval(moment())
      const isLastRunBeforeLastInterval = lastRunMoment.isBefore(lastInterval)

      if (this.runInterval === RunIntervalEnum.DAILY || isLastRunBeforeLastInterval) {
        return 'draait morgen'
      }

      const nextRun = isLastRunBeforeLastInterval ? lastInterval : lastRunMoment

      switch (this.runInterval) {
        case RunIntervalEnum.DAILY:
          nextRun.add(1, 'days')
          break
        case RunIntervalEnum.WEEKLY:
          nextRun.add(1, 'weeks')
          break
        case RunIntervalEnum.MONTHLY:
          nextRun.add(1, 'months')
          break
      }

      return 'draait over ' + nextRun.fromNow(true)
    },
  },
}
</script>

<style scoped>

</style>
